module.exports = __webpack_public_path__ + "AvenirNextLTPro-Medium.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/fonts/AvenirNextLTPro-Medium.woff
 ** module id = 193
 ** module chunks = 1
 **/